import { useCallback } from "react";

import { useSearchParams } from "react-router-dom";

export function useUpdatePageId() {
  const [searchParams, setSearchParams] = useSearchParams();

  const updatePageId = useCallback(
    (pageId: string) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("pageId", pageId);
      setSearchParams(newSearchParams);
    },
    [searchParams, setSearchParams],
  );

  return { updatePageId };
}
